import styled from '@emotion/styled'

const Container = styled.div`
  display: flex;
  justify-content: center;
`

export { Container }
